
import React from 'react';
import { IconProps } from '../../types/types';

const NewFilterIcon: React.FC<IconProps> = ({ color = '#373F51', size = '11' }) => (
    <svg width={size} height={size} viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.55254 0.47998H8.67256C9.26456 0.47998 9.75254 0.967985 9.75254 1.55999V2.74397C9.75254 3.17597 9.48055 3.71198 9.21655 3.98398L6.89658 6.03198C6.57658 6.30398 6.36055 6.83997 6.36055 7.27197V9.59199C6.36055 9.91199 6.14456 10.344 5.87256 10.512L5.12056 11C4.41656 11.432 3.44853 10.944 3.44853 10.08V7.22397C3.44853 6.84797 3.23255 6.35999 3.01655 6.08799L0.968554 3.92798C0.696554 3.65598 0.480566 3.17597 0.480566 2.84797V1.60798C0.472566 0.967983 0.960538 0.47998 1.55254 0.47998Z" stroke={color} strokeWidth="0.96" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);

export default NewFilterIcon;